/**
 * Concurrent-safe abort signal scope for ApiClient.
 * request() reads the active signal synchronously before awaiting fetch,
 * so overlapping useApi calls each capture the correct signal.
 */
const signalStack: AbortSignal[] = [];

export function runWithAbortSignal<T>(signal: AbortSignal, fn: () => Promise<T>): Promise<T> {
  signalStack.push(signal);
  try {
    return Promise.resolve(fn()).finally(() => {
      const idx = signalStack.lastIndexOf(signal);
      if (idx >= 0) signalStack.splice(idx, 1);
    });
  } catch (err) {
    const idx = signalStack.lastIndexOf(signal);
    if (idx >= 0) signalStack.splice(idx, 1);
    throw err;
  }
}

export function getActiveAbortSignal(): AbortSignal | undefined {
  return signalStack.length ? signalStack[signalStack.length - 1] : undefined;
}

export function isAbortError(err: unknown): boolean {
  if (err == null || typeof err !== 'object') return false;
  if ((err as { name?: string }).name === 'AbortError') return true;
  if (typeof DOMException !== 'undefined' && err instanceof DOMException && err.name === 'AbortError') {
    return true;
  }
  return false;
}
